import React from 'react'
import InvestorDescription from '../InvestorDescription'
import { fetchInvestorDescriptions } from './investorDescriptionsContainerActions'
import { connect } from 'react-redux'
import { investorDescriptionSelected } from '../searchCriteriaActions'
import { validateState } from '../FinancialServicesContainer/financialServicesContainerActions'
import Spinner from '../../../common/Spinners/Spinner'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';

class InvestorDescriptionContainer extends React.Component {
  static propTypes = {
    isInvalid: PropTypes.bool,
    message: PropTypes.string,
    validate: PropTypes.func.isRequired,
    investorDescriptions: PropTypes.array,
    investorDescriptionSelected: PropTypes.func.isRequired,
    selectedInvestorDescriptionId: PropTypes.number,
    fetchInvestorDescriptions: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    valid: PropTypes.bool.isRequired,
    showValidationErrors: PropTypes.bool.isRequired
  }

  shouldComponentUpdate (nextProps) {
    let { help, investorDescriptions, selectedInvestorDescriptionId, loading, valid, showValidationErrors } = this.props

    var validationstateChanged = help !== nextProps.help ||
      valid !== nextProps.valid

    var shouldUpdate = loading !== nextProps.loading ||
      selectedInvestorDescriptionId !== nextProps.selectedInvestorDescriptionId ||
      investorDescriptions?.length !== nextProps.investorDescriptions?.length ||
      validationstateChanged || showValidationErrors !== nextProps.showValidationErrors

    return shouldUpdate
  }

  constructor (props) {
    super(props)
    this.investorDescriptionSelected = this.investorDescriptionSelected.bind(this)
  }

  componentDidMount () {
    this.props.fetchInvestorDescriptions()
  }

  investorDescriptionSelected (investorDescriptionId) {
    this.props.investorDescriptionSelected(investorDescriptionId)
    this.props.validate()
  }

  render () {
    if (this.props.loading) {
      return <Spinner />
    }
    return <InvestorDescription
      investorDescriptions={this.props.investorDescriptions}
      isInvalid={this.props.isInvalid}
      message={this.props.message}
      investorDescriptionSelected={this.investorDescriptionSelected}
      selectedInvestorDescriptionId={this.props.selectedInvestorDescriptionId}
      showValidationErrors={this.props.showValidationErrors}
    />
  }
}

const mapStateToProps = (state) => {
  const { investorDescriptionsContainer, findAnIfa } = state
  return {
    investorDescriptions: investorDescriptionsContainer.investorDescriptions,
    isInvalid: findAnIfa.isInvalid.investorDescriptionContainer.valid,
    message: findAnIfa.isInvalid.investorDescriptionContainer.help,
    selectedInvestorDescriptionId: findAnIfa.searchCriteria.investorDescriptionId,
    loading: investorDescriptionsContainer.loading
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    validate: validateState,
    investorDescriptionSelected: investorDescriptionSelected,
    fetchInvestorDescriptions: fetchInvestorDescriptions
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(InvestorDescriptionContainer)
